module.exports = __webpack_public_path__ + "img/bz.989e1362.svg";